module.exports = __webpack_public_path__ + "fonts/GT-Super-Display-Super.woff2";